/* Charqui Noé · v2 · Carrito lateral, tarjetas 1 clic, pestañas, carrusel, contador de packs y club · CLEMIX 2026 */
(() => {
  'use strict';

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const currency = () => (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CLP';
  const money = (cents) => new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: currency(),
    maximumFractionDigits: currency() === 'CLP' ? 0 : 2
  }).format((Number(cents) || 0) / 100);
  const escape = (value) => String(value ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const safeURL = (value) => {
    try {
      const url = new URL(value, location.origin);
      return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
    } catch (e) {
      return '';
    }
  };
  const sized = (src, width) => {
    if (!src) return '';
    try {
      const url = new URL(src, location.origin);
      if (url.hostname.includes('cdn.shopify.com') || url.pathname.includes('/cdn/shop/')) url.searchParams.set('width', width);
      return url.href;
    } catch (e) {
      return src;
    }
  };
  const drawer = () => document.getElementById('CNCart');
  let busy = false;

  /* ---------- API carrito ---------- */
  async function api(path, data) {
    const options = data
      ? {
          method: 'POST',
          headers: data instanceof FormData ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: data instanceof FormData ? data : JSON.stringify(data)
        }
      : { cache: 'no-store', headers: { Accept: 'application/json' } };
    const response = await fetch(root + path, options);
    let result;
    try {
      result = await response.json();
    } catch (e) {
      throw new Error('No pudimos leer la respuesta. Revisa tu carrito antes de volver a intentar.');
    }
    if (!response.ok) {
      throw new Error(typeof result.description === 'string' && result.description ? result.description : 'No fue posible actualizar el carrito. Revisa la disponibilidad y vuelve a intentar.');
    }
    return result;
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cn-count]').forEach((el) => { el.textContent = cart.item_count; });
    const el = drawer();
    if (!el) return;
    const threshold = Number(el.dataset.threshold) || 0;
    const upsellText = el.dataset.upsellText || '';
    const upsellLink = el.dataset.upsellLink || root + '#packs';
    const upsellLabel = el.dataset.upsellLabel || 'Conoce los packs';
    let html = '';

    if (threshold > 0 && cart.currency === 'CLP') {
      const remaining = Math.max(0, threshold - cart.total_price);
      html += `<div class="cn-shipping"><p>${remaining ? `Te faltan <strong>${money(remaining)}</strong> para el envío gratis.` : '¡Listo! Alcanzaste el envío gratis.'}</p><progress max="${threshold}" value="${Math.min(threshold, cart.total_price)}"></progress></div>`;
    }

    if (!cart.items.length) {
      html += `<div class="cn-cart-empty"><p><strong>Tu carrito está vacío.</strong></p><p>Elige un sabor y agrégalo con un clic.</p><a class="cn-button" href="${root}#tienda" data-cn-cart-close>Ver productos</a></div>`;
    }

    cart.items.forEach((item) => {
      const props = Object.entries(item.properties || {}).filter(([k, v]) => !k.startsWith('_') && v && v !== '0');
      const image = item.image ? `<img src="${escape(safeURL(sized(item.image, 160)))}" alt="${escape(item.product_title)}" width="72" height="84" loading="lazy">` : '<div></div>';
      html += `<article class="cn-cart-line">${image}<div>
        <h3><a href="${escape(safeURL(item.url))}">${escape(item.product_title)}</a></h3>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<p>${escape(item.variant_title)}</p>` : ''}
        ${props.map(([k, v]) => `<p>${escape(k)}: ${escape(v)}</p>`).join('')}
        ${item.selling_plan_allocation ? `<p>${escape(item.selling_plan_allocation.selling_plan.name)}</p>` : ''}
        <p><strong>${money(item.final_line_price)}</strong></p>
        ${(item.line_level_discount_allocations || []).map((d) => `<p>${escape(d.discount_application.title)} −${money(d.amount)}</p>`).join('')}
        <div>
          <button type="button" data-cn-change="${escape(item.key)}" data-quantity="${item.quantity - 1}" aria-label="Reducir cantidad de ${escape(item.product_title)}">−</button>
          <input aria-label="Cantidad de ${escape(item.product_title)}" value="${item.quantity}" readonly>
          <button type="button" data-cn-change="${escape(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Aumentar cantidad de ${escape(item.product_title)}">+</button>
          <button type="button" class="cn-remove" data-cn-change="${escape(item.key)}" data-quantity="0">Quitar</button>
        </div>
      </div></article>`;
    });

    const onlySingles = cart.items.every((x) => !x.selling_plan_allocation && !Object.keys(x.properties || {}).length);
    if (upsellText && cart.item_count > 0 && cart.item_count <= 2 && onlySingles) {
      html += `<div class="cn-upsell">${escape(upsellText)}<br><a href="${escape(safeURL(upsellLink))}" data-cn-cart-close>${escape(upsellLabel)} →</a></div>`;
    }

    if (cart.items.length) {
      html += `<div class="cn-cart-summary">
        ${(cart.cart_level_discount_applications || []).map((d) => `<p>${escape(d.title)} <span>−${money(d.total_allocated_amount)}</span></p>`).join('')}
        <p>Total estimado <span>${money(cart.total_price)}</span></p>
        <p class="cn-cart-note">Despacho calculado al pagar, salvo productos con envío incluido.</p>
        <form action="${root}cart" method="post"><button name="checkout" class="cn-button" type="submit">Ir a pagar</button></form>
      </div>`;
    }

    el.querySelector('[data-cn-cart-content]').innerHTML = html;
  }

  async function openCart() {
    const el = drawer();
    if (!el || typeof el.showModal !== 'function') {
      location.href = root + 'cart';
      return;
    }
    if (!el.open) el.showModal();
    document.body.classList.add('cn-drawer-open');
    const content = el.querySelector('[data-cn-cart-content]');
    el.querySelector('[data-cn-cart-error]').textContent = '';
    content.setAttribute('aria-busy', 'true');
    try {
      renderCart(await api('cart.js'));
    } catch (error) {
      el.querySelector('[data-cn-cart-error]').textContent = error.message;
    } finally {
      content.removeAttribute('aria-busy');
    }
  }

  function closeCart() {
    const el = drawer();
    if (el && el.open) el.close();
    document.body.classList.remove('cn-drawer-open');
  }

  /* ---------- Tarjetas (pods) ---------- */
  function syncPod(pod) {
    const checked = pod.querySelector('.cn-sizes input:checked');
    if (!checked) return;
    const priceEl = pod.querySelector('[data-cn-pod-price]');
    const price = Number(checked.dataset.price);
    const compare = Number(checked.dataset.compare) || 0;
    if (priceEl) {
      if (checked.dataset.priceText) priceEl.textContent = checked.dataset.priceText;
      else priceEl.innerHTML = escape(money(price)) + (compare > price ? `<s>${escape(money(compare))}</s>` : '');
    }
    if (checked.dataset.url) pod.querySelectorAll('[data-cn-pod-link]').forEach((a) => { a.href = checked.dataset.url; });
    const cta = pod.querySelector('[data-cn-pod-cta]');
    if (cta) {
      const ok = checked.dataset.available === 'true';
      cta.disabled = !ok;
      cta.textContent = ok ? (cta.dataset.label || 'Agregar al carro') : 'Agotado';
    }
  }

  /* ---------- Pestañas de la vitrina ---------- */
  function activateTab(shop, key, scroll) {
    const tab = shop.querySelector(`[data-cn-tab="${key}"]`);
    if (!tab || tab.hidden) return;
    shop.querySelectorAll('[data-cn-tab]').forEach((b) => b.setAttribute('aria-pressed', String(b === tab)));
    let visible = 0;
    shop.querySelectorAll('[data-cn-cats]').forEach((pod) => {
      const show = key === 'all' || pod.dataset.cnCats.split(/\s+/).includes(key);
      pod.hidden = !show;
      if (show) visible += 1;
    });
    const empty = shop.querySelector('[data-cn-empty]');
    if (empty) empty.hidden = visible > 0;
    if (scroll) shop.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function initShop(shop) {
    if (shop.dataset.ready) return;
    shop.dataset.ready = 'true';
    shop.querySelectorAll('[data-cn-tab]').forEach((tab) => {
      const key = tab.dataset.cnTab;
      if (key === 'all') return;
      const count = [...shop.querySelectorAll('[data-cn-cats]')].filter((p) => p.dataset.cnCats.split(/\s+/).includes(key)).length;
      tab.hidden = count === 0;
    });
    handleHash(false);
  }

  function handleHash(scroll) {
    const hash = location.hash.replace('#', '');
    if (!hash) return;
    document.querySelectorAll('[data-cn-shop]').forEach((shop) => {
      const tab = shop.querySelector(`[data-cn-hash="${CSS.escape(hash)}"]`);
      if (tab) activateTab(shop, tab.dataset.cnTab, scroll);
    });
  }

  /* ---------- Carrusel de destacados (móvil) ---------- */
  function initCarousel(track) {
    if (track.dataset.ready) return;
    track.dataset.ready = 'true';
    const slides = [...track.children];
    const dots = track.parentElement.querySelector('[data-cn-dots]');
    if (!dots || slides.length < 2) return;
    dots.innerHTML = slides.map((_, i) => `<button type="button" tabindex="-1" data-i="${i}"></button>`).join('');
    const buttons = [...dots.children];
    const current = () => {
      const left = track.scrollLeft;
      let best = 0;
      slides.forEach((s, i) => { if (Math.abs(s.offsetLeft - track.offsetLeft - left) < Math.abs(slides[best].offsetLeft - track.offsetLeft - left)) best = i; });
      return best;
    };
    const paint = () => { const c = current(); buttons.forEach((b, i) => b.setAttribute('aria-current', String(i === c))); };
    const go = (i) => track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft - 16, behavior: 'smooth' });
    buttons.forEach((b) => b.addEventListener('click', () => go(Number(b.dataset.i))));
    track.addEventListener('scroll', () => requestAnimationFrame(paint), { passive: true });
    paint();
    let paused = false;
    ['touchstart', 'pointerdown', 'mouseenter', 'focusin'].forEach((ev) => track.addEventListener(ev, () => { paused = true; }, { passive: true }));
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduced) {
      setInterval(() => {
        if (paused || track.scrollWidth <= track.clientWidth + 4 || document.hidden) return;
        go((current() + 1) % slides.length);
      }, 5000);
    }
  }

  /* ---------- Ficha de producto ---------- */
  function packState(form) {
    const pack = form.querySelector('[data-cn-pack-count]');
    if (!pack) return { ok: true };
    const count = Number(pack.dataset.cnPackCount);
    const inputs = [...pack.querySelectorAll('[data-cn-flavor]')];
    const sum = inputs.reduce((a, i) => a + (Number(i.value) || 0), 0);
    pack.querySelector('[data-cn-pack-status]').textContent = `${sum} / ${count}`;
    pack.querySelector('[data-cn-pack-bar]').style.width = `${Math.min(100, (sum / count) * 100)}%`;
    pack.querySelector('[data-cn-pack-msg]').textContent = sum === count
      ? '¡Pack completo! Ya puedes agregarlo al carro.'
      : `Te faltan ${count - sum} ${count - sum === 1 ? 'bolsa' : 'bolsas'}. Puedes repetir sabores.`;
    inputs.forEach((input) => {
      const row = input.closest('.cn-stepper');
      row.querySelector('[data-cn-step="-1"]').disabled = Number(input.value) <= 0;
      row.querySelector('[data-cn-step="1"]').disabled = sum >= count;
    });
    return { ok: sum === count, sum, count };
  }

  function initProduct(section) {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const variantsEl = section.querySelector('[data-cn-variants]');
    const configEl = section.querySelector('[data-cn-config]');
    const form = section.querySelector('[data-cn-product-form]');
    if (!variantsEl || !configEl || !form) return;
    const variants = JSON.parse(variantsEl.textContent);
    const config = JSON.parse(configEl.textContent);
    const variantInput = form.querySelector('[data-cn-variant]');
    const planInputs = [...form.querySelectorAll('[data-cn-plan-option]')];
    const submit = form.querySelector('[data-cn-submit]');
    const priceEl = section.querySelector('[data-cn-price]');
    const wrapper = section.closest('product-component') || document;
    const sticky = wrapper.querySelector('[data-cn-sticky]');
    const stickyPrice = wrapper.querySelector('[data-cn-sticky-price]');
    const stickyBtn = wrapper.querySelector('[data-cn-sticky-btn]');

    function update(changeURL) {
      const variant = variants.find((v) => String(v.id) === String(variantInput.value));
      if (!variant) return;
      let plan = null;
      planInputs.forEach((input) => {
        input.disabled = !!input.value && !variant.plans.some((p) => String(p.id) === input.value);
        const label = input.parentElement.querySelector('[data-cn-plan-price]');
        if (label) {
          const match = input.value ? variant.plans.find((p) => String(p.id) === input.value) : null;
          label.textContent = input.value ? (match ? money(match.price) : '') : money(variant.price);
        }
      });
      let checked = planInputs.find((i) => i.checked && !i.disabled);
      if (!checked && planInputs.length) {
        checked = planInputs.find((i) => !i.disabled);
        if (checked) checked.checked = true;
      }
      if (checked && checked.value) plan = variant.plans.find((p) => String(p.id) === checked.value) || null;

      const hasPlan = !config.requiresPlan || !!plan;
      const pack = packState(form);
      const unit = plan ? plan.price : variant.price;
      submit.disabled = !variant.available || !hasPlan || !pack.ok;
      submit.textContent = !variant.available
        ? 'Agotado'
        : !hasPlan
          ? 'Suscripción no disponible'
          : !pack.ok
            ? `Elige ${pack.count - pack.sum} ${pack.count - pack.sum === 1 ? 'bolsa más' : 'bolsas más'}`
            : plan
              ? `Suscribirme · ${money(unit)}`
              : `Agregar al carro · ${money(unit)}`;
      if (priceEl) priceEl.innerHTML = escape(money(unit)) + (!plan && variant.compare > variant.price ? `<s>${escape(money(variant.compare))}</s>` : '');
      if (stickyPrice) stickyPrice.textContent = money(unit);
      if (stickyBtn) {
        stickyBtn.disabled = submit.disabled;
        stickyBtn.textContent = !pack.ok ? 'Completa tu pack' : variant.available ? (plan ? 'Suscribirme' : 'Agregar al carro') : 'Agotado';
      }
      if (changeURL) {
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        if (plan) url.searchParams.set('selling_plan', plan.id);
        else url.searchParams.delete('selling_plan');
        history.replaceState({}, '', url);
        if (variant.image) {
          const img = section.querySelector('.cn-product-main-image');
          if (img) {
            img.src = variant.image;
            img.removeAttribute('srcset');
          }
        }
      }
    }

    const selectedPlan = new URL(location.href).searchParams.get('selling_plan');
    if (selectedPlan) planInputs.forEach((i) => { if (i.value === selectedPlan) i.checked = true; });
    variantInput.addEventListener('change', () => update(true));
    planInputs.forEach((i) => i.addEventListener('change', () => update(true)));

    form.addEventListener('click', (event) => {
      const step = event.target.closest('[data-cn-step]');
      if (step) {
        const input = step.parentElement.querySelector('[data-cn-flavor]');
        const pack = packState(form);
        const delta = Number(step.dataset.cnStep);
        if (delta > 0 && pack.sum >= pack.count) return;
        input.value = Math.max(0, (Number(input.value) || 0) + delta);
        update(false);
        return;
      }
      const qty = event.target.closest('[data-cn-qty]');
      if (qty) {
        const input = form.querySelector('[data-cn-qty-input]');
        input.value = Math.min(99, Math.max(1, (Number(input.value) || 1) + Number(qty.dataset.cnQty)));
      }
    });

    if (sticky) {
      let ticking = false;
      const check = () => {
        ticking = false;
        const show = submit.getBoundingClientRect().bottom < 0 && window.innerWidth <= 760;
        if (sticky.classList.contains('is-visible') === show) return;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
        document.body.classList.toggle('cn-has-sticky', show);
      };
      const onScroll = () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(check);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      check();
    }

    update(false);
  }

  /* ---------- Clics globales ---------- */
  document.addEventListener('click', async (event) => {
    const opener = event.target.closest('[data-cn-cart-open]');
    if (opener) {
      event.preventDefault();
      openCart();
      return;
    }
    if (event.target.closest('[data-cn-cart-close]')) closeCart();

    const change = event.target.closest('[data-cn-change]');
    if (change && !busy) {
      busy = true;
      const el = drawer();
      const content = el.querySelector('[data-cn-cart-content]');
      content.classList.add('cn-cart-loading');
      el.querySelector('[data-cn-cart-error]').textContent = '';
      try {
        renderCart(await api('cart/change.js', { id: change.dataset.cnChange, quantity: Math.max(0, Number(change.dataset.quantity)) }));
        const closeBtn = el.querySelector('.cn-drawer-close');
        if (closeBtn) closeBtn.focus();
      } catch (error) {
        el.querySelector('[data-cn-cart-error]').textContent = error.message;
      } finally {
        busy = false;
        content.classList.remove('cn-cart-loading');
      }
    }

    const tab = event.target.closest('[data-cn-tab]');
    if (tab) {
      const shop = tab.closest('[data-cn-shop]');
      activateTab(shop, tab.dataset.cnTab, false);
      if (tab.dataset.cnHash) history.replaceState({}, '', '#' + tab.dataset.cnHash);
    }

    const thumb = event.target.closest('[data-cn-image]');
    if (thumb) {
      const section = thumb.closest('[data-cn-product]');
      const img = section.querySelector('.cn-product-main-image');
      if (img) {
        img.src = thumb.dataset.cnImage;
        img.removeAttribute('srcset');
        img.alt = thumb.dataset.alt || '';
      }
      section.querySelectorAll('[data-cn-image]').forEach((b) => b.setAttribute('aria-current', String(b === thumb)));
    }

    const mobileLink = event.target.closest('.cn-mobile-nav a');
    if (mobileLink) mobileLink.closest('.cn-mobile-nav').removeAttribute('open');
  });

  document.addEventListener('change', (event) => {
    const radio = event.target.closest('.cn-sizes input');
    if (radio) syncPod(radio.closest('[data-cn-pod]'));
  });

  /* ---------- Agregar al carro (tarjetas y ficha) ---------- */
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-cn-add]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.submitting || busy) return;
    const error = form.querySelector('.cn-error');
    if (error) error.textContent = '';
    const pack = packState(form);
    if (!pack.ok) {
      if (error) error.textContent = `Completa tu pack: elige ${pack.count} bolsas en total.`;
      return;
    }
    const button = form.querySelector('[type=submit]');
    if (!button || button.disabled) return;
    const old = button.textContent;
    button.disabled = true;
    button.textContent = 'Agregando…';
    form.dataset.submitting = 'true';
    busy = true;
    try {
      const data = new FormData(form);
      if (!data.get('selling_plan')) data.delete('selling_plan');
      [...data.keys()].forEach((key) => {
        if (key.startsWith('properties[') && (data.get(key) === '0' || data.get(key) === '')) data.delete(key);
      });
      await api('cart/add.js', data);
      busy = false;
      button.textContent = '¡Agregado!';
      await openCart();
    } catch (err) {
      if (error) error.textContent = err.message;
    } finally {
      setTimeout(() => {
        button.disabled = false;
        button.textContent = old;
        const product = form.closest('[data-cn-product]');
        if (product) {
          const v = form.querySelector('[data-cn-variant]');
          if (v) v.dispatchEvent(new Event('change'));
        }
      }, 900);
      delete form.dataset.submitting;
      busy = false;
    }
  });

  /* ---------- Cuenta regresiva de drops ---------- */
  function countdowns() {
    document.querySelectorAll('[data-cn-countdown]').forEach((el) => {
      const raw = el.dataset.cnCountdown;
      const end = /^\d+$/.test(raw) ? Number(raw) * 1000 : new Date(raw).getTime();
      if (!Number.isFinite(end)) return;
      const ms = end - Date.now();
      if (ms <= 0) {
        el.textContent = 'Edición finalizada';
        return;
      }
      const days = Math.floor(ms / 86400000);
      const hours = Math.floor(ms / 3600000) % 24;
      const minutes = Math.floor(ms / 60000) % 60;
      el.textContent = days > 0 ? `Termina en ${days} días y ${hours} h` : `Termina en ${hours} h y ${minutes} min`;
    });
  }

  /* ---------- Encabezado fijo (sin el mensaje superior) ---------- */
  function headerOffset() {
    const ann = document.querySelector('.cn-announcement');
    document.documentElement.style.setProperty('--cn-header-top', ann ? `-${ann.offsetHeight}px` : '0px');
  }

  function init(scope) {
    const s = scope || document;
    s.querySelectorAll('[data-cn-pod]').forEach(syncPod);
    s.querySelectorAll('[data-cn-shop]').forEach(initShop);
    s.querySelectorAll('[data-cn-carousel]').forEach(initCarousel);
    s.querySelectorAll('[data-cn-product]').forEach(initProduct);
    headerOffset();
    const el = drawer();
    if (el && !el.dataset.bound) {
      el.dataset.bound = 'true';
      el.addEventListener('click', (event) => {
        if (event.target === el) {
          const r = el.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeCart();
        }
      });
      el.addEventListener('close', () => document.body.classList.remove('cn-drawer-open'));
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  window.addEventListener('hashchange', () => handleHash(true));
  window.addEventListener('resize', headerOffset, { passive: true });
  countdowns();
  setInterval(countdowns, 60000);

  if (new URL(location.href).searchParams.get('cn_cart') === 'open') openCart();
})();